import { render, staticRenderFns } from "./MsgUnread.vue?vue&type=template&id=b5a07cdc&scoped=true"
import script from "./MsgUnread.vue?vue&type=script&lang=js"
export * from "./MsgUnread.vue?vue&type=script&lang=js"
import style1 from "./MsgUnread.vue?vue&type=style&index=1&id=b5a07cdc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a07cdc",
  null
  
)

export default component.exports